import { Record as record} from 'immutable';

import { construct, fields } from '../../../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../helpers/Records';

const schema = {
    name: [ fields.string ],
    nlc: [ fields.string ]
};

class CollectionLocation extends record(getDefaults(schema)) {
    static fromJSON(json) {
        return construct(CollectionLocation, json, getResolvers(schema));
    }
}

export default CollectionLocation;
